<template>
  <div class="home-page" style="padding-top: 80px">
    <!-- Main Banner -->
    <section class="main-banner">
      <div class="h-full flex items-center bg-opacity-50 bg-black">
        <div class="container mx-auto">
          <div class="text-center text-white mb-8">
            <h2>Find Your Dream Home</h2>
            <p>​Find the key to your future home sweet home</p>
          </div>
          <div
            class="bg-white p-6 rounded-lg flex flex-col md:flex-row relative"
          >
            <PropertiesSearch
              mode="horizontal"
              :expanded="searchExpanded"
              v-model="filter"
              class="w-full"
            />
            <div class="hidden md:grid grid-cols-2 gap-2">
              <a
                class="
                  flex
                  items-center
                  justify-center
                  rounded-full
                  ml-8
                  bg-primary-color
                "
                style="width: 58px; height: 52px"
                @click="search"
              >
                <eva-icon name="search-outline" height="25" />
              </a>
              <a
                class="flex items-center justify-center mx-3 pt-1"
                style="height: 52px; padding-top: 5px"
                @click="searchExpanded = !searchExpanded"
              >
                <eva-icon name="expand-outline" height="32" />
              </a>
            </div>
            <div class="grid grid-cols-3 gap-4 md:hidden mt-5">
              <a
                class="
                  col-span-2
                  w-full
                  flex
                  items-center
                  justify-center
                  rounded-xl
                  p-2
                  bg-primary-color
                  text-black
                "
                @click="search"
              >
                <eva-icon name="search-outline" height="25" class="mr-2" />
                Search
              </a>
              <a
                class="flex items-center justify-center mx-3 pt-1"
                style="height: 52px; padding-top: 5px"
                @click="searchExpanded = !searchExpanded"
              >
                <eva-icon name="expand-outline" height="32" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- List your property -->
    <section class="list-your-property">
      <div class="container mx-auto">
        <div class="flex flex-col md:flex-row justify-between">
          <div>
            <h2 class="text-2xl md:text-3xl text-center md:text-left">List your property with us</h2>
            <p class="text-center md:text-left">
              We will keep in contact with the landlords and tenants throughout
              the contract, in case of any issues, <br class="hidden md:block" />
              we are your mediators in the northern area
            </p>
          </div>
          <div class="flex justify-center">
            <router-link :to="`/contact-us`">
              <a class="btn btn-dark mt-4">Contact Us Now</a>
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <!-- Feature Properties -->
    <section class="feature-property bg-background-light p-6 md:p-12">
      <div class="container mx-auto">
        <div class="text-center mb-12">
          <h2>Featured Properties</h2>
          <p>Handpicked properties by our team.</p>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div
            v-for="(property, index) in featuredProperties
              .filter((x) => x.photos.length)
              .slice(0, 3)"
            :key="'propertyBoxStyle' + index"
          >
            <PropertyBoxStyle
              :key="`property-box-${index}`"
              :property="property"
            />
          </div>
        </div>
      </div>
    </section>

    <!-- Property Cities -->
    <section class="property-city p-6 md:p-12">
      <div class="container mx-auto">
        <div class="text-center mb-12">
          <h2>Find Properties in These Cities</h2>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <FeaturedCities :city="cities[0]" />
          </div>
          <div class="col-span-1 md:col-span-2">
            <FeaturedCities :city="cities[1]" />
          </div>
          <div class="col-span-1 md:col-span-2">
            <FeaturedCities :city="cities[2]" />
          </div>
          <div>
            <FeaturedCities :city="cities[3]" />
          </div>
        </div>
      </div>
    </section>

    <!-- Why Chose Us -->
    <section class="why-chose bg-background-light p-6 md:p-12">
      <div class="container mx-auto">
        <div class="text-center mb-12">
          <h2>Why Choose Us</h2>
          <p>We are your mediators in the Northern Area</p>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-10">
          <div
            v-for="(reason, index) in reasons"
            :key="'whyUsReason' + index"
            class="col-span-1"
            v-bind:class="reason.span ? `md:col-span-${reason.span}` : ''"
          >
            <WhyUsReason v-bind="reason" />
          </div>
        </div>
      </div>
    </section>

    <!-- Our Testimonials -->
    <section class="our-testimonials">
      <div>
        <div class="container mx-auto p-6 md:p-12">
          <div class="mb-12 text-center">
            <h2>Testimonials</h2>
            <p>Here is what our customers have to say about us.</p>
          </div>
          <div class="testimonial-slider">
            <iframe
              src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fmarijana.stanic2%2Fposts%2F10220924792898220&show_text=true&width=500"
              style="width: 100%; height: 170px"
              scrolling="no"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import carousel from "vue-owl-carousel";

import { WhyUsReason, FeaturedCities } from "@/components/atoms";
import { PropertiesSearch, PropertyBoxStyle } from "@/components/molecules";

export default {
  components: {
    carousel,

    PropertyBoxStyle,
    FeaturedCities,

    PropertiesSearch,

    WhyUsReason,
  },
  data: function () {
    return {
      filter: {},
      searchExpanded: false,
      reasons: [
        {
          iconStyle: "far",
          icon: "eye",
          title: "Vision",
          description:
            "To become Malta’s leading letting real estate agency in the Northern and Central area and the preferred place of employment for real estate professionals. We consistently endeavor to develop partnerships, based on transparency and mutual trust, which serve to build everlasting relationships with our tenants and landlords.",
        },
        {
          icon: "bullseye",
          title: "Mission",
          description:
            "Commitment to achieve our Vision through our Core Values and to inspire a positive & lasting impact. We aim only excellence and to exceed expectations in everything we do. We support our highly skilled team to be better every day and see possibilities instead of limitations.",
        },
        {
          span: 2,
          iconStyle: "far",
          icon: "gem",
          title: "Core Values",
          description:
            "Our core values emanate throughout every activity that we undertake: <br><br><ul><li class='mb-2'><b>Commitment, Excellence & Integrity</b>: We deliver what we promise from the first contact to after sales service;</li><li class='mb-2'><b>Love</b>: We love our tenants, landlords and team. We spoil you for choice and make your moving experience fun.</li><li class='mb-2'><b>Respect</b>: Listen to our tenants’ and landlords’ needs, create a flexible, fun and respectful environment for our team and respect our planet;</li><li><b>Experience</b>: Over 24 years of experience in residential letting.</li></ul>",
        },
      ],
      cities: [
        {
          name: "Mellieha Area",
          areas: [10587, 26572, 10575, 26577, 26573, 26574, 26575, 26576],
          image: "mellieha-area.jpg",
        },
        {
          name: "Saint Paul's Bay / Buggiba Area",
          areas: [26570, 26571, 10600],
          image: "saint-pauls-area.jpg",
        },
        {
          name: "Central Area",
          areas: [
            26578, 26579, 26580, 26581, 10567, 10588, 10591, 10610, 10573,
            10556, 10557, 10594, 10602,
          ],
          image: "central-area.jpg",
        },
        {
          name: "Burmarrad Area",
          areas: [26582, 26583, 26584],
          image: "burmarrad-area.jpg",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("Properties", {
      featuredProperties: "featuredProperties",
    }),
  },
  methods: {
    ...mapActions("Properties", {
      getFeaturedProperties: "getFeaturedProperties",
    }),
    search: function () {
      this.$router.push({
        name: "Properties",
        query: {
          ref_no: this.filter.ref_no,
          property_types:
            this.filter.property_type_id &&
            this.filter.property_type_id.length &&
            this.filter.property_type_id.join(","),
          cities:
            this.filter.city_id &&
            this.filter.city_id.length &&
            this.filter.city_id.join(","),
          price:
            this.filter.price &&
            this.filter.price.value.length &&
            this.filter.price.value.join(","),
          bedrooms: this.filter.bedrooms,
          main_bathrooms: this.filter.main_bathrooms,
        },
      });
    },
  },
  beforeMount: function () {
    if (!this.featuredProperties.length) {
      this.getFeaturedProperties();
    }
  },
};
</script>

<style lang="scss" scoped>
.main-banner {
  @apply bg-cover bg-center text-white;
  background-image: url("~@/assets/homepage-banner.jpg");
  height: calc(100vh - 80px);
}

.our-testimonials {
  @apply bg-cover bg-center text-white;
  background-image: url("~@/assets/testimonials-banner.jpg");

  & > div {
    background: rgba(0, 0, 0, 0.4);
  }

  .testimonial-slider {
    @apply mx-auto;
    max-width: 550px;
  }
}

.list-your-property {
  @apply bg-primary-color p-10;
}
</style>
